import api from '@/plugins/api';

export const commissionService = {
    get() { return api.get('/commissions'); },
};
